import html2canvas from "html2canvas-pro/dist/html2canvas-pro.esm.js";
import { jsPDF } from "jspdf";
import moment from "moment";
import React from "react";
import { useCallback } from "react";
import { toast } from "react-toastify";
import { swingLibraryService } from "../../../../../services/swingLibrary";
import { useUserData } from "../../../../../hooks/useUserData";

export const usePdfGeneration = ({ actionSdkResponse, golfClub, userId }) => {
  const { userData } = useUserData();

  const generatePDF = useCallback(
    async (userNameForFileName, pageRefs) => {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = 210;

      const addPageToPDF = async (ref, isFirstPage) => {
        if (!ref.current) return;
        const canvas = await html2canvas(ref.current, {
          allowTaint: false,
          backgroundColor: "#ffffff",
          logging: false,
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        const imgHeight = (canvas.height * pageWidth) / canvas.width;
        if (!isFirstPage) pdf.addPage();
        pdf.addImage(
          imgData,
          "JPEG",
          0,
          0,
          pageWidth,
          imgHeight,
          undefined,
          "FAST"
        );
      };

      for (let i = 0; i < pageRefs.length; i++) {
        await addPageToPDF(pageRefs[i], i === 0);
      }

      const pdfBlob = new Blob([pdf.output("arraybuffer")], {
        type: "application/pdf",
      });
      const fileName = `${userNameForFileName}_${golfClub}_${moment().valueOf()}.pdf`;

      try {
        const reportURL = await swingLibraryService.uploadPdfToReportsFolder(
          pdfBlob,
          fileName
        );

        if (!userData?.uid) throw new Error("Not authenticated");

        await swingLibraryService.createSwingScoreReport({
          averageScore: 0,
          clubCategory: golfClub === "D" ? "Driver" : "Iron",
          clubName: golfClub,
          coachId: userData.uid,
          report: actionSdkResponse || {},
          reportURL,
          selectedGoals: {},
          swingResults: {},
          userId,
        });

        await swingLibraryService.spendReportCredit({
          amount: "0",
          coachId: userData.uid,
          creditCount: 1,
          creditType: "reportCredits",
          status: "complete",
          transactionType: "out",
          userId,
        });

        return reportURL;
      } catch (error) {
        console.error("Error finalizing PDF report:", error);
        toast.error(error?.message || "Upload failed");
        return null;
      }
    },
    [actionSdkResponse, golfClub, userData, userId]
  );

  return {
    generatePDF,
  };
};
